// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--89227";
export var imageContainer = "style-module--imageContainer--c4a64";
export var imageWithText = "style-module--imageWithText--eb0c0";
export var textArea = "style-module--textArea--2be22";